module.exports = __webpack_public_path__ + "img/serviceVision.d0daf61a.png";